import { useState } from 'react'

export const InformationState = () => {
    const [filter, setFilter] = useState({toggled: false})
    const [menuAnchor, setMenuAnchor] = useState({current: null, toggled: false})
    const [info, setInfo] = useState({method:'', detailed: null ,id:'', data:[]})
    const [test, setTest] = useState({toggled: false, name:''})
    const [exam, setExam ] = useState();
    const [tc, setTc] = useState({status:0, progress: 0, pretest:null, vl:1, quiz:null, posteval:null})
    const [prog, setProg] = useState({pretest: 0, vl:0, quiz:0, posteval:0})
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [act, setAct] = useState(false);
    
    // Pretest, Quiz, Post Eva
    const [ans, setAns] = useState([])
    const [correctAnswers, setCorrectAnswers] = useState(0);
    const [validationError, setValidationError] = useState('');
    const [disablePagination, setDisablePagination] = useState(false);
    const [selectCategory, setselectCategory] = useState([])
    const [trainingProgress, setTrainingProgress] = useState({});

    //generate
    const [show, setShow] = useState(true);

    return {
        filter: {data:filter, set:setFilter},
        menuAnchor: {data: menuAnchor, set: setMenuAnchor},
        show: {data: show, set: setShow},
        info: {data: info, set: setInfo},
        test: {data: test, set: setTest},
        exam: {data: exam, set: setExam},
        tc: {data: tc, set: setTc},
        prog: {data: prog, set: setProg},
        cqIndex: {data: currentQuestionIndex, set: setCurrentQuestionIndex},
        act: {data: act, set: setAct},
        ans: {data: ans, set: setAns},
        correctAnswers: {data: correctAnswers, set: setCorrectAnswers},
        validationError: {data: validationError, set: setValidationError},
        disablePagination: {data: disablePagination, set: setDisablePagination},
        selectCategory: {data: selectCategory, set: setselectCategory},
        trainingProgress: { data: trainingProgress, set: setTrainingProgress },

    }
}
